import {
  BooleanInput,
  CheckboxGroupInput,
  DateField,
  Filter,
  FunctionField,
  NumberField,
  SelectInput,
  TextField,
  TextInput,
  usePermissions,
} from 'react-admin'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { CustomBooleanField } from '../../components/Fields'
import { BundleChoices, CarrierMCChoices } from '../../helpers/constants'
import { ProductSubscriptionStripeStatus } from '../../models/productSubscription'
import { FeatureNamesMap, ProductSubscriptionBundleName } from '../../models/subscription'
import { hasPermission, Permissions } from '../../Permissions'
import { CTDatagrid } from '../CTDatagrid'
import CTList from '../List'
import { TeamStripeSubscriptionStatus } from './TeamStripeSubscription'

const TeamFilter = (props: any) => {
  const { permissions } = usePermissions()
  const canFilterByProduct = hasPermission(permissions || [], Permissions.FilterTeamByProduct)
  usePageTitle('Teams')

  return (
    <Filter {...props}>
      <TextInput label="Search" source="search" alwaysOn />
      <BooleanInput label="Team Is Approved" source="is_approved" />
      <BooleanInput label="Team Is Real" source="is_real" />
      <SelectInput
        label="Product Subscription"
        source="latest_product_subscription__bundle_name"
        choices={BundleChoices}
      />
      <SelectInput
        label="Carrier"
        source="latest_product_subscription__carrier__mc_number"
        choices={CarrierMCChoices}
      />
      {canFilterByProduct && (
        <CheckboxGroupInput
          label="Product"
          source="latest_product_subscription__items__product__name"
          choices={FeatureNamesMap}
        />
      )}
    </Filter>
  )
}

const TeamList = (props: any) => (
  <CTList bulkActionButtons={false} filters={<TeamFilter />} {...props}>
    <CTDatagrid optimized>
      <TextField source="name" />
      <DateField source="date_created" options={{ timeZoneName: 'short' }} />
      <CustomBooleanField source="is_approved" />
      <FunctionField
        label="Product Subscription"
        render={(record: any) => (
          <FlexBox gap="10px" alignItems="flex-start">
            <span>{record.bundle_name}</span>
            {(record?.product_subscription?.stripe_subscription_status !==
              ProductSubscriptionStripeStatus.NOT_APPLICABLE ||
              record.bundle_name === ProductSubscriptionBundleName.FLEX_STARTER) && (
              <div>
                <TeamStripeSubscriptionStatus
                  status={record?.product_subscription?.stripe_subscription_status}
                  size="small"
                />
              </div>
            )}
          </FlexBox>
        )}
      />
      <TextField label="Carrier" source="product_subscription.carrier.name" />
      <TextField source="location_city" />
      <TextField source="location_state" />
      <NumberField source="mc_number" />
      <NumberField source="dot_number" />
    </CTDatagrid>
  </CTList>
)

export default TeamList
